module.exports = __webpack_public_path__ + "img/037-i love you.7318c9ff.svg";